import React, { Component } from 'react'
import './style.css'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'
import {Button} from '@material-ui/core'
export default class tribe_services extends Component {

    render() {
        const {data,is_footer}=this.props
        return (
            <div>
                <div className='grid-services-wrapper'>
                    {data.map((data,i)=>(
                        <div key={i} style={{display:'flex',flexDirection:'column'}}>
                        <div className='box-img-overlay'>
                            <img src={data.img} className='box-img'/>
                        </div>
                        <div className='box-content'>
                            <h3>{data.title}</h3>
                            <br/>
                            <p>{data.content}</p>
                        </div>
                        {is_footer!==undefined&&is_footer===false?null:
                        <div className='box-footer'>
                            <Button style={{textTransform:'none'}} onClick={()=>window.location.assign(data.link)} color="primary">Read more detail</Button>
                        </div>
                        }
                        </div>
                    ))}
                   
                    
                </div>
            </div>
        )
    }
}
